import { render, staticRenderFns } from "./PhototypeTemplate.vue?vue&type=template&id=73450076"
import script from "./PhototypeTemplate.vue?vue&type=script&lang=js"
export * from "./PhototypeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports